export interface NewsItem {
  id: string;
  title: string;
  date: string;
  tag: string;
  summary: string;
  cover: string;
  content: string[];
}

export const newsList: NewsItem[] = [
  {
    id: 'taboo-4-premiere',
    title: '《美国式禁忌4》正式上线：一场关于秘密与救赎的银幕之旅',
    date: '2026-10-12',
    tag: '新片上线',
    summary:
      '备受期待的电影《美国式禁忌4》今日正式与观众见面，影片以冷峻克制的叙事风格，讲述了一个关于家族秘密与人性抉择的悬疑故事。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20premiere%20still%20of%20a%20rainy%20coastal%20city%20at%20dusk%20with%20reflective%20wet%20streets%20and%20distant%20warm%20window%20lights%2C%20deep%20indigo%20and%20charcoal%20palette%20with%20orange%20accents%2C%20atmospheric%20moody%20tone%2C%20film%20grain%2C%20editorial%20cinematic%20composition&width=800&height=500&seq=news-cover-01&orientation=landscape',
    content: [
      '经过长时间的筹备与打磨，电影《美国式禁忌4》于今日正式上线，为观众带来一段充满张力的银幕旅程。影片以一位调查记者的视角切入，层层揭开一桩被尘封多年的旧案。',
      '导演乔纳森·雷德福在谈到创作初衷时表示，他希望影片在悬疑的外壳之下，真正探讨的是人与人之间难以言说的信任与隔阂。“每个人都藏着秘密，而秘密本身并不是终点，我们真正关心的，是人们如何面对它。”',
      '影片在视觉呈现上延续了系列一贯的冷峻风格，大量采用自然光与长镜头，让观众能够沉浸在故事营造的氛围之中。配乐方面则刻意保持克制，将情绪的起伏交给画面本身去承担。',
      '对于喜爱悬疑与人性题材的观众而言，《美国式禁忌4》无疑是一部值得细细品味的作品。它并不急于给出答案，而是邀请观众一同走进那段被雨水浸透的记忆。',
    ],
  },
  {
    id: 'taboo-4-cast-interview',
    title: '主演访谈：《美国式禁忌4》中最难的一场戏，我们拍了整整八天',
    date: '2026-10-09',
    tag: '幕后专访',
    summary:
      '在接受采访时，主演艾米莉亚·卡特分享了拍摄过程中最令她难忘的经历，以及她如何理解所饰演的调查记者这一角色。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20interview%20scene%20of%20an%20empty%20dark%20film%20studio%20with%20a%20single%20chair%20under%20a%20warm%20spotlight%2C%20deep%20blue%20surroundings%20with%20amber%20key%20light%2C%20intimate%20contemplative%20mood%2C%20film%20grain%2C%20minimal%20editorial%20composition&width=800&height=500&seq=news-cover-02&orientation=landscape',
    content: [
      '“有一场戏，我们拍了整整八天。”主演艾米莉亚·卡特在谈到《美国式禁忌4》时这样说。那场戏发生在临海的废弃别墅，全片情绪最为紧绷的转折点也正是在那里展开。',
      '为了呈现角色内心逐渐崩塌的过程，导演要求剧组尽可能减少台词，依靠表演与镜头语言去传递信息。“那是一种很奇妙的体验，你必须把所有的东西都放在眼神和呼吸里。”',
      '谈到对角色的理解，艾米莉亚认为，她所饰演的调查记者并非传统意义上的英雄，而是一个同样带着伤痕、不断在自我怀疑中前行的人。',
      '“我希望观众看到的不只是一个查案的人，而是一个在真相面前，同样会害怕、会犹豫的普通人。”',
    ],
  },
  {
    id: 'october-drama-guide',
    title: '十月影视指南：五部不容错过的高分美剧与电影',
    date: '2026-10-05',
    tag: '影视推荐',
    summary:
      '秋意渐浓，正是窝在沙发里追剧的好时节。本期我们为你精选了五部近期口碑出色的影视作品，涵盖悬疑、剧情与年代题材。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20cozy%20home%20theater%20scene%20at%20night%20with%20warm%20ambient%20glow%20and%20a%20large%20screen%20casting%20soft%20blue%20light%2C%20moody%20relaxed%20atmosphere%2C%20deep%20indigo%20and%20amber%20palette%2C%20film%20grain%2C%20minimal%20editorial%20composition&width=800&height=500&seq=news-cover-03&orientation=landscape',
    content: [
      '随着气温逐渐下降，越来越多的人选择在夜晚窝进沙发，打开一部期待已久的剧集。本月有多部作品上线，题材覆盖悬疑、家庭剧情与年代史诗。',
      '其中，《家族禁区》以慢热却扎实的叙事收获了不少好评；《边界之影》则凭借辽阔的自然景观与克制的情感表达，成为本季口碑黑马。',
      '电影方面，《灰色地带》选择回归庭审题材，用一场漫长的辩论追问正义的边界；而《无声告白》则以细腻的家庭叙事打动了许多观众。',
      '当然，本月的绝对焦点依然是《美国式禁忌4》。无论你是系列的老观众，还是第一次走进这个故事的新面孔，它都值得你留出一个安静的夜晚。',
    ],
  },
  {
    id: 'taboo-series-retrospective',
    title: '回顾「禁忌」系列：十五年，我们如何讲述秘密这件事',
    date: '2026-09-28',
    tag: '深度解析',
    summary:
      '从第一部到如今的第四部，「禁忌」系列陪伴观众走过了十五个年头。我们回顾这一系列在叙事与视觉上的演变轨迹。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20retrospective%20collage%20still%20of%20noir%20city%20streets%20and%20empty%20rooms%20in%20a%20muted%20blue%20and%20charcoal%20palette%20with%20warm%20amber%20highlights%2C%20nostalgic%20melancholic%20mood%2C%20film%20grain%2C%20editorial%20cinematic%20composition&width=800&height=500&seq=news-cover-04&orientation=landscape',
    content: [
      '十五年前，第一部《禁忌》以极低的成本面世，却在影迷之间口口相传。那时的它关注的是一个家庭的秘密，而如今，这个系列已经把视野扩展到了更广阔的人性图景。',
      '系列最大的变化，或许是叙事节奏上的从容。早期作品依赖反转与悬念，而近几部则更愿意花时间停留在一个眼神、一次沉默之上。',
      '视觉风格同样经历了显著的演变：从高对比的黑白硬光，到如今以低饱和蓝灰为主、辅以暖色点缀的色板，系列逐渐找到了属于自己的气质。',
      '不变的是，它始终在追问同一个问题——当我们选择隐瞒时，究竟是保护了别人，还是伤害了自己。',
    ],
  },
  {
    id: 'behind-the-scenes-filming',
    title: '探班《美国式禁忌4》片场：一场雨，等了整整两周',
    date: '2026-09-21',
    tag: '幕后花絮',
    summary:
      '为了捕捉到最真实的海边雨夜氛围，剧组在片场守候了整整两周。我们走进拍摄现场，记录下这些不为人知的细节。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20film%20set%20at%20night%20with%20rain%20rigs%20and%20soft%20blue%20lighting%20haze%20over%20a%20coastal%20location%2C%20warm%20orange%20practical%20lights%20in%20the%20distance%2C%20atmospheric%20moody%20tone%2C%20film%20grain%2C%20documentary%20style%20composition&width=800&height=500&seq=news-cover-05&orientation=landscape',
    content: [
      '在《美国式禁忌4》众多令人印象深刻的场景中，那场海边雨夜的戏份无疑是全片的情绪高点。为了等一场足够真实的雨，剧组在海岸边守候了整整两周。',
      '“我们本可以用人工降雨，但自然雨的那种质感是无法替代的。”摄影指导这样解释。当真正的雨终于落下时，全组几乎是在欢呼中开机的。',
      '由于海边风大浪急，许多镜头都只能拍一两条。演员们在寒冷中反复走位，只为呈现出角色此刻的孤独与决绝。',
      '这份近乎固执的坚持，最终化作了银幕上那几分钟令人屏息的画面。',
    ],
  },
  {
    id: 'soundtrack-release',
    title: '《美国式禁忌4》原声带上线：克制，才是最高级的情绪',
    date: '2026-09-15',
    tag: '影视音乐',
    summary:
      '影片原声带正式发布，作曲家以极简的旋律与大量留白，为这部悬疑作品营造出独特的听觉空间。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20moody%20still%20of%20a%20grand%20piano%20in%20a%20dark%20empty%20hall%20lit%20by%20a%20single%20cool%20blue%20window%20with%20a%20warm%20amber%20accent%2C%20introspective%20serene%20mood%2C%20deep%20indigo%20palette%2C%20film%20grain%2C%20minimal%20editorial%20composition&width=800&height=500&seq=news-cover-06&orientation=landscape',
    content: [
      '如果说画面是《美国式禁忌4》的骨架，那么音乐就是它呼吸的方式。原声带一经上线，便凭借极简而动人的旋律获得了不少听众的喜爱。',
      '作曲家提到，自己在创作时刻意回避了宏大的编排。“当你面对一个沉重的故事，最有力的表达往往是沉默，以及沉默之后那几个恰到好处的音符。”',
      '整张原声带以钢琴与弦乐为主，大量使用留白，让听众能够在旋律的间隙中，听见自己的情绪。',
      '“我希望音乐不是告诉观众该有什么感受，而是为他们留出感受的空间。”',
    ],
  },
  {
    id: 'top-suspense-movies',
    title: '从《美国式禁忌4》出发：悬疑片如何做到「不靠反转也好看」',
    date: '2026-09-09',
    tag: '深度解析',
    summary:
      '反转并非悬疑片的唯一武器。本文以《美国式禁忌4》为例，聊聊一部优秀的悬疑作品，如何用氛围与人物撑起整个故事。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20analytical%20still%20of%20a%20lone%20detective%20figure%20silhouetted%20against%20a%20foggy%20blue%20city%20window%20with%20warm%20desk%20lamp%20glow%2C%20contemplative%20noir%20mood%2C%20deep%20indigo%20and%20amber%20palette%2C%20film%20grain%2C%20minimal%20editorial%20composition&width=800&height=500&seq=news-cover-07&orientation=landscape',
    content: [
      '很多观众习惯用“有没有反转”来衡量一部悬疑片的好坏，但真正优秀的作品往往并不依赖反转。《美国式禁忌4》就是一个很好的例子。',
      '它把大量的篇幅留给了人物的犹豫、沉默与选择。观众在观看过程中，感受到的不是“被欺骗”，而是“被带入”——这正是氛围营造的力量。',
      '而这种氛围，来自方方面面：低饱和的色调、克制的配乐、缓慢而笃定的镜头运动，以及演员们那些不易察觉的细微表情。',
      '当一部悬疑片愿意相信观众的耐心，它收获的往往不只是“猜到了结局”的满足，而是更长久、更复杂的回味。',
    ],
  },
  {
    id: 'october-new-additions',
    title: '本月新增影视资源一览：悬疑与剧情题材持续升温',
    date: '2026-09-02',
    tag: '资源更新',
    summary:
      '本月我们为影视库新增了多部作品，涵盖电影与剧集两个类别。快来看看有没有你在等待的那一部吧。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20dimly%20lit%20home%20screening%20room%20with%20rows%20of%20empty%20seats%20and%20a%20glowing%20screen%2C%20deep%20blue%20ambient%20light%20with%20warm%20amber%20accents%2C%20moody%20atmospheric%20tone%2C%20film%20grain%2C%20minimal%20editorial%20composition&width=800&height=500&seq=news-cover-08&orientation=landscape',
    content: [
      '为了让影迷们有更丰富的选择，本月我们更新了一大批影视资源，题材依旧以悬疑与剧情类为主。',
      '电影方面，最新上线的《美国式禁忌4》与《暗流之下》都收获了不错的口碑；剧集方面，《欲望之城》与《第七夜》也陆续更新完毕，可以一次看个痛快。',
      '如果你偏爱温情一些的作品，《无声告白》或许会是一个不错的选择。它没有激烈的冲突，却能在平静的日常中击中人心。',
      '我们会持续关注新作品的上线动态，努力为每一位观众带来更好的观影体验。',
    ],
  },
];